import { useEffect, useState } from 'react'

/** Значение, которое догоняет исходное после паузы: расчёт не дёргается на каждую цифру. */
export function useDebounced<T>(value: T, ms: number): T {
  const [settled, setSettled] = useState(value)
  useEffect(() => {
    const timer = setTimeout(() => {
      setSettled(value)
    }, ms)
    return () => {
      clearTimeout(timer)
    }
  }, [value, ms])
  return settled
}
